import { render, staticRenderFns } from "./FormMailingAddressQuestion.vue?vue&type=template&id=2cf8aa35"
import script from "./FormMailingAddressQuestion.vue?vue&type=script&lang=js"
export * from "./FormMailingAddressQuestion.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports